// Mock data for Fiquant Consult Ltd website

export const companyInfo = {
  name: "Fiquant Consult Ltd",
  shortName: "Fiquant Consult",
  tagline: "Transforming Business, Empowering Growth",
  description: "Nigeria's premier consulting firm delivering excellence in business consulting, tax advisory, risk management, and compliance services.",
  location: "Lagos, Nigeria",
  email: "info@fiquantconsult.com",
  phone: "+234 (0) 810 830 5575",
  address: "1 Simeon Abam Lane, Port Harcourt, Rivers State, Nigeria",
  founded: "2018",
  logoUrl: "https://customer-assets.emergentagent.com/job_tax-risk-experts/artifacts/swcoobns_Fiquant%20Logo%20Gold%20-%20Bold%20Diamond%20%28Transparent%29.png",
  logoTextUrl: "https://customer-assets.emergentagent.com/job_tax-risk-experts/artifacts/pi461b9t_FIQUANT%20CONSULT%20NAME%20-%20FONT%20TRANSPARENT%20CLEAN.png"
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "Products", path: "/products" },
  { name: "Library", path: "/library" },
  { name: "About Us", path: "/about" },
  { name: "Contact Us", path: "/contact" }
];

export const services = [
  {
    id: 1,
    title: "Business Consulting",
    shortDesc: "Strategic guidance for sustainable growth",
    description: "We provide comprehensive business consulting services to help organizations navigate complex challenges and capitalize on emerging opportunities in the Nigerian market.",
    icon: "briefcase",
    features: [
      "Strategic Planning & Execution",
      "Market Entry Strategy",
      "Organizational Restructuring",
      "Performance Improvement",
      "Mergers & Acquisitions Advisory"
    ]
  },
  {
    id: 2,
    title: "Tax Consulting & Advisory",
    shortDesc: "Optimizing your tax position",
    description: "Our tax experts help businesses navigate Nigeria's complex tax landscape, ensuring compliance while optimizing tax efficiency.",
    icon: "calculator",
    features: [
      "Tax Planning & Optimization",
      "Corporate Tax Compliance",
      "Transfer Pricing",
      "VAT Advisory",
      "Tax Dispute Resolution"
    ]
  },
  {
    id: 3,
    title: "Risk Consulting",
    shortDesc: "Protecting your business interests",
    description: "We help organizations identify, assess, and mitigate risks while building resilient frameworks for sustainable operations.",
    icon: "shield",
    features: [
      "Enterprise Risk Management",
      "Internal Audit Services",
      "Fraud Investigation",
      "Regulatory Compliance",
      "Crisis Management"
    ]
  },
  {
    id: 4,
    title: "Business Process Optimisation & Compliance",
    shortDesc: "Streamlining operations for efficiency",
    description: "Transform your operations with our process optimization services, ensuring regulatory compliance and operational excellence.",
    icon: "settings",
    features: [
      "Process Reengineering",
      "Compliance Framework Design",
      "Quality Management Systems",
      "Digital Transformation",
      "Standard Operating Procedures"
    ]
  }
];

export const products = [
  {
    id: 1,
    name: "FQ Compliance Suite",
    description: "An integrated compliance management platform for Nigerian businesses",
    features: ["Regulatory tracking", "Automated reporting", "Risk assessment tools"]
  },
  {
    id: 2,
    name: "TaxOptima Pro",
    description: "Tax planning and calculation software tailored for Nigerian tax laws",
    features: ["Tax calculations", "Filing assistance", "Compliance calendar"]
  },
  {
    id: 3,
    name: "RiskGuard Analytics",
    description: "Enterprise risk monitoring and analytics dashboard",
    features: ["Real-time monitoring", "Predictive analytics", "Custom reports"]
  },
  {
    id: 4,
    name: "ProcessFlow Manager",
    description: "Business process mapping and optimization tool",
    features: ["Process mapping", "Bottleneck identification", "Performance metrics"]
  }
];

export const insights = [
  {
    id: 1,
    category: "ARTICLE",
    title: "Navigating Nigeria's New Tax Reforms: What Businesses Need to Know",
    excerpt: "The recent changes to Nigeria's tax framework present both challenges and opportunities for businesses operating in the region.",
    author: "Dr. Adebayo Okonkwo",
    date: "July 15, 2025",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600"
  },
  {
    id: 2,
    category: "PODCAST",
    title: "CEO Perspectives: Building Resilient Businesses in West Africa",
    excerpt: "Leading executives share their strategies for building sustainable and resilient businesses in the dynamic West African market.",
    author: "Fiquant Leadership Series",
    date: "July 10, 2025",
    readTime: "32 min listen",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600"
  },
  {
    id: 3,
    category: "REPORT",
    title: "Digital Transformation in Nigerian Banking: 2025 Outlook",
    excerpt: "Our latest report examines how Nigerian banks are leveraging technology to enhance customer experience and operational efficiency.",
    author: "Fiquant Research Team",
    date: "July 5, 2025",
    readTime: "15 min read",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600"
  },
  {
    id: 4,
    category: "ARTICLE",
    title: "Risk Management Best Practices for SMEs",
    excerpt: "Small and medium enterprises face unique risks. Here's how to build a robust risk management framework.",
    author: "Chioma Nwosu",
    date: "June 28, 2025",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600"
  }
];

export const caseStudies = [
  {
    id: 1,
    client: "Leading Nigerian Bank",
    title: "Achieving 40% Reduction in Compliance Costs",
    description: "How we helped a top-tier bank streamline their compliance processes and reduce operational costs.",
    results: ["40% cost reduction", "60% faster reporting", "Zero compliance violations"]
  },
  {
    id: 2,
    client: "Oil & Gas Company",
    title: "Tax Optimization Saving ₦500M Annually",
    description: "Strategic tax planning that delivered significant savings while ensuring full regulatory compliance.",
    results: ["₦500M annual savings", "100% compliance rate", "Improved cash flow"]
  },
  {
    id: 3,
    client: "Manufacturing Conglomerate",
    title: "Digital Transformation of Finance Operations",
    description: "End-to-end process automation that transformed the client's finance function.",
    results: ["75% faster close", "90% fewer errors", "Real-time visibility"]
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Oluwaseun Adeyemi",
    role: "Managing Partner",
    bio: "20+ years of consulting experience across Africa",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300"
  },
  {
    id: 2,
    name: "Amara Obi",
    role: "Head of Tax Advisory",
    bio: "Former FIRS official with deep tax expertise",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300"
  },
  {
    id: 3,
    name: "Emeka Chukwu",
    role: "Director, Risk Consulting",
    bio: "Specialist in enterprise risk management",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300"
  },
  {
    id: 4,
    name: "Fatima Ibrahim",
    role: "Head of Business Process",
    bio: "Expert in operational excellence and transformation",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300"
  }
];

export const stats = [
  { value: "150+", label: "Clients Served" },
  { value: "₦50B+", label: "Client Value Created" },
  { value: "7+", label: "Years of Excellence" },
  { value: "98%", label: "Client Retention" }
];

export const testimonials = [
  {
    id: 1,
    quote: "Fiquant Consult transformed our approach to risk management. Their expertise and dedication are unmatched.",
    author: "CFO, Leading Nigerian Bank",
    company: "Financial Services"
  },
  {
    id: 2,
    quote: "The tax optimization strategies implemented by Fiquant have significantly improved our bottom line while ensuring compliance.",
    author: "CEO, Manufacturing Company",
    company: "Manufacturing"
  },
  {
    id: 3,
    quote: "Their business process consulting helped us achieve operational excellence and sustainable growth.",
    author: "Managing Director, Tech Startup",
    company: "Technology"
  }
];

export const footerLinks = {
  services: [
    { name: "Business Consulting", path: "/services#business" },
    { name: "Tax Advisory", path: "/services#tax" },
    { name: "Risk Consulting", path: "/services#risk" },
    { name: "Process Optimisation", path: "/services#process" }
  ],
  company: [
    { name: "About Us", path: "/about" },
    { name: "Leadership", path: "/about#team" },
    { name: "Careers", path: "/careers" },
    { name: "Contact", path: "/contact" }
  ],
  resources: [
    { name: "Insights", path: "/insights" },
    { name: "Case Studies", path: "/case-studies" },
    { name: "Publications", path: "/publications" },
    { name: "Events", path: "/events" }
  ]
};

export const socialLinks = [
  { name: "LinkedIn", url: "https://linkedin.com", icon: "linkedin" },
  { name: "Twitter", url: "https://twitter.com", icon: "twitter" },
  { name: "Facebook", url: "https://facebook.com", icon: "facebook" },
  { name: "Instagram", url: "https://instagram.com", icon: "instagram" }
];
